/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Reason_Tax_Country_MissingInputs */



/**
* | output |
* | --- |
* | "Tax country not set · required before invoicing" |
*
* @param {Partner_Billing_Board_Reason_Tax_Country_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_reason_tax_country_missing = /** @type {((inputs?: Partner_Billing_Board_Reason_Tax_Country_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Reason_Tax_Country_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Steuerland nicht gesetzt · vor der Fakturierung erforderlich")
	return /** @type {LocalizedString} */ ("Tax country not set · required before invoicing")
});